export const validateDonationForm = (data, updating = false) => {
    const errors = {};
    const isEmpty = (val) => !val || !val.toString().trim();

    // סכום
    if (!data.amount || isNaN(data.amount) || data.amount <= 0) {
        errors.amount = "יש להזין סכום תקין";
    }

    // מטבע
    if (isEmpty(data.currency)) errors.currency = "יש לבחור סוג מטבע";

    // אמצעי תשלום
    if (isEmpty(data.paymentMethod)) {
        errors.paymentMethod = "יש לבחור אמצעי תשלום";
    } else {
        if (data.paymentMethod === "credit" && !updating) { 
            if (isEmpty(data.cardHolderName)) errors.cardHolderName = "יש להזין שם בעל הכרטיס";
            if (isEmpty(data.cardHolderId)) errors.cardHolderId = "יש להזין תעודת זהות";
        }
        if (data.paymentMethod === "recurring") {
            if (isEmpty(data.bankNumber)) errors.bankNumber = "יש להזין מספר בנק";
            if (isEmpty(data.bankAccount)) errors.bankAccount = "יש להזין מספר חשבון";
            if (isEmpty(data.bankBranch)) errors.bankBranch = "יש להזין סניף";
            if (isEmpty(data.accountHolder)) errors.accountHolder = "יש להזין שם בעל החשבון";
        }
    }

    // תשלומים
    if (data.installments && (isNaN(data.installments) || data.installments < 1)) {
        errors.installments = "מספר תשלומים חייב להיות לפחות 1";
    }

    return errors;
};
